import Vue from 'vue'
import VueRouter from 'vue-router'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import IndexInfo from '../pages/mine/IndexInfo.vue'/* 菜单 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import RechargeList from '../pages/mine/RechargeList.vue'/* 充值记录 */

import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import FundRecord from '../pages/mine/FundRecord.vue'/* 资金记录 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Start from '../pages/start/index.vue'/* 开始页面 */
import LotteryRecord from '../pages/lottery/record.vue'/* 彩票投注记录 */
import Membership from '../pages/membership/index.vue'/* 会员等级页面 */
import Notice from '../pages/mine/Notice.vue'/* 留言板（站内信） */
import SysNotice from '../pages/mine/SysNotice.vue'/* 系统公告（公告配置） */
import Message from '../pages/mine/Message.vue'/* 站内信 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import Details from '../pages/mine/details'

Vue.use(VueRouter)
const routes = [
    // {path:'/',redirect:'/Home',component:Home,meta:{title:'첫 페이지'}},
    // {path:'/Home',name:'home',component:Home,meta:{title:'첫 페이지'}},
	// {path:'/Choose',name:'choose',component:Choose,meta:{title:'첩을 선택하세요'}},
	// {path:'/List',name:'list',component:List,meta:{title:'선택된 첩 목록'}},
	// {path:'/Profile',name:'profile',component:Profile,meta:{title:'첩 선택 세부 사항'}},
    // {path:'/Mine',name:'mine',component:Mine,meta:{title:'내 거'}},
    // {path:'/Video',name:'video',component:Video,meta:{title:'동영상'}},
    // {path:'/Game',name:'game',component:Game,meta:{title:'게임'}},
    // {path:'/Login',name:'login',component:Login,meta:{title:'로그인'}},
    // {path:'/Register',name:'register',component:Register,meta:{title:'등록하다'}},
    // {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'온라인 고객 서비스'}},
    // {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'온라인 고객 서비스'}},
    // {path:'/Setting',name:'Setting',component:Setting,meta:{title:'설정'}},
    // {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'기본정보'}},
    // {path:'/IndexInfo',name:'IndexInfo',component:IndexInfo,meta:{title:'설정'}},
    // {path:'/Setname',name:'Setname',component:Setname,meta:{title:'실명 변경'}},
    // {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'성별 수정'}},
    // {path:'/Language',name:'Language',component:Language,meta:{title:'언어 선택'}},
    // {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'충전하다'}},
    // {path:'/RechargeList',name:'RechargeList',component:RechargeList,meta:{title:'충전하다'}},
    
    // {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'결제 비밀번호 관리'}},
    // {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'로그인 비밀번호 관리'}},
    // {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'세부정보 페이지'}},
    // {path:'/Notice',name:'Notice',component:Notice,meta:{title:'정보발표'}},
    // {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'비디오 재생'}},
    // {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'결제 카드를 작성하세요'}},
    // {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'결제 카드를 작성하세요'}},
    // {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'현금 인출'}},
    // {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'개인 보고서'}},
    // {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'출금기록'}},
    // {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'작업 기록'}},
    // {path:'/detail',name:'Details',component:Details}
    {path:'/',redirect:'/Home'},
    {path:'/Home',name:'home',component:Home,meta:{title:'Hinge Club', requiresAuth: false}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'Hinge Club', requiresAuth: false}},
	{path:'/List',name:'list',component:List,meta:{title:'Hinge Club', requiresAuth: false}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'Hinge Club', requiresAuth: false}},
	{path:'/profile',redirect:'/Profile'},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'Hinge Club', requiresAuth: false}},
    {path:'/Video',name:'video',component:Video,meta:{title:'Hinge Club', requiresAuth: false}},
    {path:'/Game',name:'game',component:Game,meta:{title:'Hinge Club', requiresAuth: false}},
    {path:'/game_n',name:'game_n',component:Game,meta:{title:'Hinge Club', requiresAuth: false}},
    {path:'/Login',name:'login',component:Login,meta:{title:'Hinge Club', requiresAuth: false}},
    {path:'/Register',name:'register',component:Register,meta:{title:'Hinge Club', requiresAuth: false}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'Hinge Club', requiresAuth: false}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'Hinge Club', requiresAuth: false}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'Hinge Club'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'Hinge Club'}},
    {path:'/IndexInfo',name:'IndexInfo',component:IndexInfo,meta:{title:'Hinge Club'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'Hinge Club'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'Hinge Club'}},
    {path:'/Language',name:'Language',component:Language,meta:{title:'Hinge Club', requiresAuth: false}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'Hinge Club'}},
    {path:'/RechargeList',name:'RechargeList',component:RechargeList,meta:{title:'Hinge Club'}},
    
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'Hinge Club'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'Hinge Club'}},
    {path:'/FundRecord',name:'FundRecord',component:FundRecord,meta:{title:'Hinge Club'}},
    {path:'/Account',redirect:'/FundRecord'},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'Hinge Club'}},
    {path:'/LotteryRecord',name:'LotteryRecord',component:LotteryRecord,meta:{title:'Hinge Club'}},
    {path:'/Start',name:'start',component:Start,meta:{title:'Hinge Club'}},
    {path:'/Membership',name:'membership',component:Membership,meta:{title:'Hinge Club', requiresAuth: false}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'Hinge Club', requiresAuth: false}},
    {path:'/MessageBoard',name:'MessageBoard',component:Notice,meta:{title:'Hinge Club', requiresAuth: false}},
    {path:'/SysNotice',name:'SysNotice',component:SysNotice,meta:{title:'Hinge Club'}},
    {path:'/Message',name:'Message',component:Message,meta:{title:'Hinge Club'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'Hinge Club'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'Hinge Club'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'Hinge Club'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'Hinge Club'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'Hinge Club'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'Hinge Club'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'Hinge Club'}},
    {path:'/detail',name:'Details',component:Details,meta:{title:'Hinge Club'}}

];

//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to, from, next) => {
    document.title = to.matched[0].meta.title

    const token = localStorage.getItem('token')
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false)

    if (!token && requiresAuth) {
        next({ path: '/Login', replace: true })
        return
    }

    if (token && (to.name === 'login' || to.name === 'register')) {
        next({ path: '/Home', replace: true })
        return
    }

    next()
})

export default router